import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgArrowMediumLeft32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M19.354 9.646a.5.5 0 0 0-.707 0L12.293 16l6.354 6.354a.5.5 0 0 0 .707-.708L13.707 16l5.647-5.646a.5.5 0 0 0 0-.708" /></SvgIcon>;
};
const Memo = memo(SvgArrowMediumLeft32);
export default Memo;